import { render, staticRenderFns } from "./SpaceSeo.vue?vue&type=template&id=42691272&scoped=true"
import script from "./SpaceSeo.vue?vue&type=script&lang=ts"
export * from "./SpaceSeo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42691272",
  null
  
)

export default component.exports